/**
 * collection-scroll-hover.js
 *
 * En dispositivos táctiles (sin hover real), activa la imagen secundaria
 * de cada tarjeta de colección cuando entra en el viewport al hacer scroll.
 */
(function () {
  // Solo actuar en pantallas táctiles — (pointer: coarse) funciona
  // correctamente tanto en DevTools como en dispositivos reales
  if (!window.matchMedia('(pointer: coarse)').matches) return;

  function initScrollImageSwap(sectionId) {
    var items = document.querySelectorAll(
      '#shopify-section-' + sectionId + ' .collection-list__item .collection-card-hover-wrap.has-hover-image'
    );
    if (!items.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var wrapper = entry.target.closest('.card-wrapper');
          if (wrapper) {
            wrapper.classList.toggle('scroll-active', entry.isIntersecting);
          }
        });
      },
      { threshold: 0, rootMargin: '-40% 0px -40% 0px' }
    );

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  // Exponer para que la sección lo llame con su ID
  window.CollectionScrollHover = window.CollectionScrollHover || {};
  window.CollectionScrollHover.init = initScrollImageSwap;

  // Si el inline script ya disparó el evento antes de que este defer cargara,
  // procesar las peticiones pendientes
  var pending = window.CollectionScrollHover._pending || [];
  pending.forEach(function (id) { initScrollImageSwap(id); });
  window.CollectionScrollHover._pending = null;
})();
